import { useNewScreenQuery } from '@intigral/domain/lib/presentation/hooks/useNewScreenQuery';
import { getUserInfo } from '../utils/user';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { NewScreenComponent } from './NewScreen';
import { filterComponents } from '../utils/filterComponents';

type ProvidersScreenProps = {
    screenKey: string;
    screenName: string;
};

const ProvidersScreen: React.FC<ProvidersScreenProps> = ({ screenKey, screenName }) => {
    const userInfo = getUserInfo();
    const [searchParams] = useSearchParams();
    const [selectedProviderCarousels, setSelectedProviderCarousels] = useState([]);

    const updateSelect = (item) => {
        const filteredCarousels = providers.filter((provider) => provider.id === item)[0]?.carousels ?? null;
        setSelectedProviderCarousels(filteredCarousels);
    };

    const { isLoading, isError, data, error } = useNewScreenQuery(
        screenName,
        screenKey,
        'deviceType=pc',
        userInfo.apiKey
    );

    const providers = data?.data?.content?.filters.filter((provider) => provider?.active) ?? [];

    useEffect(() => {
        if (searchParams.get('providerId') !== null) {
            if (providers?.length > 0) {
                providers.find((provider) => provider.id === searchParams.get('providerId'))
                    ? updateSelect(searchParams.get('providerId'))
                    : updateSelect(providers[0]?.id);
            }
        } else {
            updateSelect(providers[0]?.id);
        }
    }, [providers, searchParams.get('providerId')]);

    const filteredComponents = filterComponents(selectedProviderCarousels || []);

    return (
        <>
            <NewScreenComponent
                isLoading={isLoading}
                isError={isError}
                components={filteredComponents}
                screenKey={screenKey}
            />
        </>
    );
};

export default ProvidersScreen;
